import type { ReactNode } from "react";
import { cn } from "./cn";
import { Ikon, type IkonAdi } from "./Ikon";

/**
 * NOT KUTUSU — ikonlu, renkli, kenarlıklı bilgi bloğu
 *
 * ================================================================
 * NEDEN AYRI BİR BİLEŞEN
 * ================================================================
 * Çizim paketinde en az yedi ekranda aynı kutu var: kimlik
 * ekranları, kurtarma kodu uyarısı, çıkış bildirimi, jeton
 * geçersiz. Her birinde elle yazılan bir `div` olsaydı ton adları
 * (`uyari-800` mi `uyari-700` mü) ekrandan ekrana kayardı — ve
 * kontrast borcunu bu proje daha önce tam olarak böyle biriktirdi.
 *
 * ================================================================
 * TON BİR RENK DEĞİL, BİR CÜMLE
 * ================================================================
 *   bilgi   "bunu bilmen yeterli"     — eylem beklemiyor
 *   onay    "iyi haber, oldu"          — sonuç bildiriyor
 *   uyari   "dikkat et, kaybedebilirsin"
 *   hata    "bir şey ters gitti"
 *
 * Hepsini `uyari` yapmak en kolayı ve en kötüsü: her kutu uyarınca
 * hiçbiri uyarmıyor.
 *
 * `Rozet` ile karıştırma: rozet bir DURUM ETİKETİ (tek kelime, satır
 * içinde), bu ise bir CÜMLE taşıyor.
 */

export type NotTonu = "bilgi" | "onay" | "uyari" | "hata";

const TON: Record<NotTonu, string> = {
  bilgi: "border-marka-200 bg-marka-50 text-marka-700",
  onay: "border-onay-200 bg-onay-50 text-onay-700",
  uyari: "border-uyari-200 bg-uyari-50 text-uyari-800",
  hata: "border-hata-200 bg-hata-50 text-hata-700",
};

/** Ton kendi ikonunu getiriyor; çağıran `ikon` ile değiştirebiliyor. */
const VARSAYILAN_IKON: Record<NotTonu, IkonAdi> = {
  bilgi: "bilgi",
  onay: "tamam",
  uyari: "uyari",
  hata: "hata",
};

export interface NotKutusuProps {
  ton?: NotTonu;
  ikon?: IkonAdi;
  /**
   * `role="alert"` — YALNIZCA kullanıcının işlemi sonucu BELİREN bir
   * kutuda. Sayfayla birlikte gelen bir açıklamayı duyurmak, ekran
   * okuyucu kullanıcısını her sayfa açılışında sözünü kesen bir
   * anonsla karşılar.
   */
  duyur?: boolean;
  children: ReactNode;
  className?: string;
}

export function NotKutusu({
  ton = "bilgi",
  ikon,
  duyur = false,
  children,
  className,
}: NotKutusuProps) {
  return (
    <div
      role={duyur ? "alert" : undefined}
      className={cn(
        "rounded-alan flex gap-2.5 border px-3.5 py-3 text-[13px] leading-[1.6]",
        TON[ton],
        className,
      )}
    >
      {/* İkon `aria-hidden`; anlamı taşıyan şey metnin kendisi. */}
      <Ikon ad={ikon ?? VARSAYILAN_IKON[ton]} boyut="kucuk" className="mt-0.5 shrink-0" />
      <span>{children}</span>
    </div>
  );
}
